import { messageTranslations } from "./MessageTranslations.slice";

export const messageTranslationsActions = messageTranslations.actions;
